import { render, staticRenderFns } from "./_Deplesi.vue?vue&type=template&id=5f9eb118&"
import script from "./_Deplesi.vue?vue&type=script&lang=js&"
export * from "./_Deplesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports